import { useQuery } from "@tanstack/react-query";
import { fetchNews } from "@/utils/dashboardFetch";

export const useNewsQuery = () => {
    return useQuery({
        queryKey: ['news'],
        queryFn: fetchNews,
        staleTime: 1000 * 60 * 15, // 15 minutes
    });
};
